// import barba from './modules/barba/index.js'
import includes from '../../includes/**/*.js'
// import jump from './modules/jump/index.js'
import lazyLoad from './modules/lazyload/index.js'
import modules from '../../modules/**/*.js'
import partials from '../../partials/**/*.js'
import site from './modules/site/index.js'

function init() {
  // jump()
  // barba()
  lazyLoad()
  site()

  Object.keys(includes).forEach((item) => {
    const include = includes[item]

    if (
      include &&
      Object.prototype.hasOwnProperty.call(include[item], 'default')
    ) {
      include[item].default()
    }
  })

  Object.keys(modules).forEach((item) => {
    const module = modules[item]

    if (
      module &&
      Object.prototype.hasOwnProperty.call(module[item], 'default')
    ) {
      module[item].default()
    }
  })

  Object.keys(partials).forEach((item) => {
    const partial = partials[item]

    if (
      partial &&
      Object.prototype.hasOwnProperty.call(partial[item], 'default')
    ) {
      partial[item].default()
    }
  })
}

export default init
